/* @flow weak */

const React = require('react');
const ReactDOM = require('react-dom');
const _ = require('lodash');

const Config = require('../../configs/Config.js');
const Loader = require('../../loaders');
const ln = Loader.ln || 'en_US';
const AnswerActions = require('../../actions/AnswerActions.jsx');
const QuestionStore = require('../../stores/QuestionStore.jsx');

const ImageMagnifier = require('./ImageMagnifier.jsx');

const LiquifireImagePreviewSection = React.createClass({
  propTypes: {
    productData: React.PropTypes.object,
    answers: React.PropTypes.object,
    visData: React.PropTypes.object
  },

  getInitialState() {
    return {
      activeImage: 0,
      activeExtraImage: null,
      imageUrl: '',
      imageLoaded: false,
      imageNativeWidth: 0,
      imageNativeHeight: 0,
      scrollIndex: null
    };
  },

  imgRenderConfig: {},
  extraProductImages: [],
  spinnerTop: 100,

  componentWillMount() {
    let imgConfig = Config.images;
    let productData = this.props.productData;

    let id = _.get(productData, 'metadata.ImageRendererID') || productData.id;
    let cat = _.get(productData, 'metadata.ImageRendererCat') || imgConfig.imageRendererCat;

    this.imgRenderConfig = {
      keyedQuestions: QuestionStore.getImageKeyedQuestions(),
      endPoint: imgConfig.liquifire.imageRendererEndPoint,
      views: _.get(productData, 'metadata.ImageRendererViews') || imgConfig.imageRendererViews,
      configString: `id[${id}],` +
        `cat[${cat}]` +
        `&call=url[file:${imgConfig.imageRendererEnv}/index.chain.txt]` +
        `&scale=width[800]` +
        `&sink=format[png]`
    };

    this.extraProductImages = _.get(this.props.productData, 'metadata.ExtraProductImage') || [];

    this.setState({
      imageUrl: this.buildImageUrl(this.imgRenderConfig.keyedQuestions, this.props.answers, this.state.activeImage)
    });
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props && !nextProps.visData.delayRender) {
      // if the question that was just answered has a view associated with it, switch to that view
      let activeQuestion = _.findWhere(nextProps.answers, { lastAnswered: true });
      let activeView = _.get(activeQuestion, 'question.metadata.ImageRenderView');
      let activeViewIndex = this.state.activeImage;
      let activeExtraIndex = this.state.activeExtraImage;

      if (activeView && this.imgRenderConfig.views.indexOf(activeView) !== -1) {
        activeViewIndex = this.imgRenderConfig.views.indexOf(activeView);
      }

      let imageUrl = activeExtraIndex != null ? Config.images.s3url + this.extraProductImages[activeExtraIndex] :
        this.buildImageUrl(this.imgRenderConfig.keyedQuestions, nextProps.answers, activeViewIndex);

      if (imageUrl !== this.state.imageUrl || activeViewIndex !== this.state.activeImage) {
        this.setState({
          activeImage: activeViewIndex,
          activeExtraImage: activeExtraIndex,
          imageUrl: imageUrl,
          imageLoaded: false
        });
      }
    }
  },

  handleSlide(index, extraIndex, extraUrl) {
    AnswerActions.clearLastAnswered();

    this.setState({
      activeImage: index,
      activeExtraImage: extraIndex,
      imageUrl: extraUrl ? Config.images.s3url + extraUrl : this.buildImageUrl(this.imgRenderConfig.keyedQuestions, this.props.answers, index)
    });
  },

  scrollToElement(right) {
    const node = ReactDOM.findDOMNode(this);
    var carousel = node.querySelector('.uc-carousel');
    var image = node.querySelector('.uc-image-nav-img');

    carousel.scrollTo({
      left: carousel.scrollLeft + (right ? image.offsetWidth : -image.offsetWidth),
      behavior: 'smooth'
    });
  },

  scrollToNext(index, count) {
    if (index == count) {
      return;
    }

    index++;
    this.scrollToElement(true);
    this.setState({
      scrollIndex: index
    });
  },

  scrollToPrev(index, minCount) {
  if (index == minCount) {
    return;
  }

  index--;

  this.scrollToElement(false);
    this.setState({
      scrollIndex: index
    });
  },

  buildImageUrl(questions, answers, viewIndex) {
    let renderConfig = this.imgRenderConfig;

    let answerString = _.chain(questions)
      .map(question => {
        let answer = answers[question.id];
        let renderKeys = [];

        let renderKey = _.get(question, 'metadata.ImageRenderKey');
        let renderValue = String(_.get(answer, 'input') ||
          _.get(answer, 'part.metadata.ImageRenderValue') ||
          // _.get(answer, `part.metadata.lang.${ln}.DisplayName`) ||
          _.get(question, 'metadata.ImageRenderDefaultValue') ||
          '');

        if (_.get(question, 'metadata.LPConvertSlashesToTildes')) {
          renderValue = renderValue.replace(/\//g, '~');
        }

        renderValue = renderValue.replace(/\;/g, 'U003B');
        renderValue = renderValue.replace(/\&/g, 'U0026amp;');
        renderValue = renderValue.replace(/\+/g, 'U002B');
        renderValue = renderValue.replace(/\#/g, '%23');
        renderValue = renderValue.replace(/\!/g, 'U0021');
        renderValue = renderValue.replace(/\,/g, 'U002C');
        renderValue = renderValue.replace(/\'/g, 'U0027');
        renderValue = renderValue.replace(/\"/g, 'U0022');
        renderValue = renderValue.replace(/\=/g, 'U003D');
        renderValue = renderValue.replace(/\(/g, 'U0028');
        renderValue = renderValue.replace(/\)/g, 'U0029');
        renderValue = renderValue.replace(/\:/g, 'U003A');
        renderValue = renderValue.replace(/\?/g, 'U003F');
        renderValue = renderValue.replace(/\</g, 'U003C');
        renderValue = renderValue.replace(/\./g, 'U002E');
        renderValue = renderValue.replace(/\//g, 'U002F');
        // Greek letters 
        renderValue = renderValue.replace(/\Α/g, 'U0041');
        renderValue = renderValue.replace(/\Β/g, 'U0042');
        renderValue = renderValue.replace(/\Γ/g, 'U0047');
        renderValue = renderValue.replace(/\Δ/g, 'U0044');
        renderValue = renderValue.replace(/\Ε/g, 'U0045');
        renderValue = renderValue.replace(/\Ζ/g, 'U005A');
        renderValue = renderValue.replace(/\Η/g, 'U0048');
        renderValue = renderValue.replace(/\Θ/g, 'U0051');
        renderValue = renderValue.replace(/\Ι/g, 'U0049');
        renderValue = renderValue.replace(/\Κ/g, 'U004B');
        renderValue = renderValue.replace(/\Λ/g, 'U004C');
        renderValue = renderValue.replace(/\Μ/g, 'U004D');
        renderValue = renderValue.replace(/\Ν/g, 'U004E');
        renderValue = renderValue.replace(/\Ξ/g, 'U0058');
        renderValue = renderValue.replace(/\Ο/g, 'U004F');
        renderValue = renderValue.replace(/\Π/g, 'U0050');
        renderValue = renderValue.replace(/\Ρ/g, 'U0052');
        renderValue = renderValue.replace(/\Σ/g, 'U0053');
        renderValue = renderValue.replace(/\Τ/g, 'U0054');
        renderValue = renderValue.replace(/\Υ/g, 'U0055');
        renderValue = renderValue.replace(/\Φ/g, 'U0046');
        renderValue = renderValue.replace(/\Χ/g, 'U0043');
        renderValue = renderValue.replace(/\Ψ/g, 'U0059');
        renderValue = renderValue.replace(/\Ω/g, 'U0057');

        renderKeys.push({ renderKey: renderKey, renderValue: renderValue });

        // if secondary render keys are present on the question, cycle through them and push to the renderKeys array
        let secondaryKeys = _.get(question, 'metadata.SecondaryImageRenderKeys');

        if (secondaryKeys) {
          _.forIn(secondaryKeys, (value, key) => {
            let secondaryKey = value;
            let secondaryValue = _.get(answer, 'part.metadata.SecondaryImageRenderValues.' + key) ||
              _.get(question, 'metadata.SecondaryImageRenderDefaultValues.' + key) ||
              '';

            renderKeys.push({ renderKey: secondaryKey, renderValue: secondaryValue });
          });
        }

        return renderKeys;
      })
      .reduce((previousValue, currentValue) => {
        let newKeys = '';

        _.each(currentValue, value => {
          newKeys += `${value.renderKey}[${value.renderValue}],`;
        });

        return `${previousValue}${newKeys}`;
      }, '');

    let imageUrl = `${renderConfig.endPoint}` +
      `?set=${answerString}` +
      `view[${renderConfig.views[viewIndex]}],` +
      `${renderConfig.configString}`;

    AnswerActions.setProductImage(imageUrl, viewIndex, renderConfig.views[viewIndex]);

    return imageUrl;
  },

  getImageAlt(viewIndex, extraIndex = null) {
    let name = _.get(this.props.productData, `metadata.lang.${ln}.DisplayName`) || _.get(this.props.productData, 'name');
    let alt = extraIndex ? name + " extra image: " + this.extraProductImages[extraIndex]: 
      name + " " + this.imgRenderConfig.views[viewIndex] + " view";
    return alt;
  },

  imageLoaded(e) {
    this.spinnerTop = (ReactDOM.findDOMNode(this.previewImage).offsetHeight / 2);

    this.setState({
      imageNativeWidth: e.target.naturalWidth,
      imageNativeHeight: e.target.naturalHeight,
      imageLoaded: true
    });
  },

  render() {
    let renderConfig = this.imgRenderConfig;
    let alt = this.getImageAlt(this.state.activeImage, this.state.activeExtraIndex);
    // only implement ImageMagnifier if enabled and for larger resolutions
    let previewImage = (Config.features.enableHoverZoom && window.innerWidth >= Config.breakpoints.small) ?
      (
        <ImageMagnifier
          image={{
            alt: alt,
            src: this.state.imageUrl,
            nativeWidth: this.state.imageNativeWidth,
            nativeHeight: this.state.imageNativeHeight
          }}
          onLoad={this.imageLoaded} />
      ) : (
        <img alt={alt} src={this.state.imageUrl} onLoad={this.imageLoaded} />
      );
    
    let imagesCarouselMinCount = window.innerWidth > Config.breakpoints.small && window.innerWidth < 1180 ? 3 : 4;

    let imagesCount = renderConfig.views.length + this.extraProductImages.length;
    let carousel = imagesCount > imagesCarouselMinCount;
    
    return (
      <div className='uc-image-preview-section' style={{ padding: Config.features.previewImgZoomBtn ? '36px 0 0' : 0 }}>
        
          <img className="uc-image-loading" alt={Config.images.s3url + 'uc_image_loading.gif'} 
            style={{ opacity: this.state.imageLoaded ? 0 : 1}} 
            src={Config.images.s3url + 'uc_image_loading.gif'}> 
          </img>

        <div className='uc-image-preview' style={{ opacity: this.state.imageLoaded ? 1 : 0 }}>
          {Config.features.previewImgZoomBtn ?
            <i className='uc-zoom-btn fa fa-expand'
              onClick={this.props.enlargeImage.bind(null, this.state.imageUrl)}
              style={{ display: this.state.imageLoaded ? 'block' : 'none' }}> </i>
            : null}

          <div ref={(c) => { this.previewImage = c }} className='uc-preview-image'>
            {previewImage}
          </div>

          {!carousel ? <div className='uc-image-nav' style={{ display: renderConfig.views.length <= 1 && this.extraProductImages.length < 1 ? 'none' : null }}>
            {_.map(renderConfig.views, (angle, index) => {
              let activeClass = this.state.activeImage === index ? ' uc-active' : '';

              return (
                <div className={'uc-image-nav-img' + activeClass}
                  key={index}
                  onClick={this.state.activeImage !== index ? this.handleSlide.bind(null, index, null, null) : null}>
                  <img
                    alt={this.getImageAlt(index)}
                    src={this.buildImageUrl(renderConfig.keyedQuestions, this.props.answers, index)}
                    style={{ display: !this.state.imageLoaded ? 'none' : null }} />
                </div>
              );
            })}
            {_.map(this.extraProductImages, (extraUrl, index) => {
              let activeClass = this.state.activeExtraImage === index ? ' uc-active' : '';

              return (
                <div className={'uc-image-nav-img' + activeClass}
                  key={index}
                  onClick={this.state.activeExtraImage !== index ? this.handleSlide.bind(null, null, index, extraUrl) : null}>
                  <img
                    alt={this.getImageAlt(null, index)}
                    src={Config.images.s3url + extraUrl}
                    style={{ display: !this.state.imageLoaded ? 'none' : null }} />
                </div>
              );
            })}
          </div> :
            <div className='uc-image-nav uc-carousel'>
              <button style={{ opacity: this.state.scrollIndex == imagesCarouselMinCount || this.state.scrollIndex == null ? 0.5 : 1}}
                onClick={this.scrollToPrev.bind(null, this.state.scrollIndex || imagesCarouselMinCount, imagesCarouselMinCount)}
                className='uc-carousel-button-left'></button>
              {_.map(renderConfig.views, (angle, index) => {
                let activeClass = this.state.activeImage === index ? ' uc-active' : '';

                return (
                  <div className={'uc-image-nav-img' + activeClass + ' image-' + index}
                    key={index}
                    onClick={this.state.activeImage !== index ? this.handleSlide.bind(null, index, null, null) : null}>
                    <img
                      alt={this.getImageAlt(index)}
                      src={this.buildImageUrl(renderConfig.keyedQuestions, this.props.answers, index)}
                      style={{ display: !this.state.imageLoaded ? 'none' : null }} />
                  </div>
                );
              })}
              {_.map(this.extraProductImages, (extraUrl, index) => {
              let activeClass = this.state.activeExtraImage === index ? ' uc-active' : '';

              return (
                <div className={'uc-image-nav-img' + activeClass}
                  key={index}
                  onClick={this.state.activeExtraImage !== index ? this.handleSlide.bind(null, null, index, extraUrl) : null}>
                  <img
                    alt={this.getImageAlt(null, index)}
                    src={Config.images.s3url + extraUrl}
                    style={{ display: !this.state.imageLoaded ? 'none' : null }} />
                </div>
              );
            })}
              <button style={{ opacity: this.state.scrollIndex == imagesCount ? 0.5 : 1}} className='uc-carousel-button-right'
                onClick={this.scrollToNext.bind(null, this.state.scrollIndex || imagesCarouselMinCount, imagesCount)}>
              </button>
            </div>
          }
        </div>
      </div>
    );
  }
});

module.exports = LiquifireImagePreviewSection;


// WEBPACK FOOTER //
// ./src/base/scripts/components/section/LiquifireImagePreviewSection.jsx